var map = {
	"./background-overview.jpg": 618,
	"./background.jpg": 619,
	"./base/elements-repaired/3d-base.svg": 620,
	"./base/elements-repaired/3d-printer.svg": 621,
	"./base/elements-repaired/background.svg": 622,
	"./base/elements-repaired/base.svg": 623,
	"./base/elements-repaired/communication.svg": 624,
	"./base/elements-repaired/crater.svg": 625,
	"./base/elements-repaired/dome.svg": 626,
	"./base/elements-repaired/dorms.svg": 627,
	"./base/elements-repaired/drone.svg": 628,
	"./base/elements-repaired/entrance.svg": 629,
	"./base/elements-repaired/garage.svg": 630,
	"./base/elements-repaired/greenhouse.svg": 631,
	"./base/elements-repaired/hidden-base.svg": 632,
	"./base/elements-repaired/ice.svg": 633,
	"./base/elements-repaired/lab.svg": 634,
	"./base/elements-repaired/rocket.svg": 635,
	"./base/elements-repaired/rover-curiosity.svg": 636,
	"./base/elements-repaired/satellite.svg": 637,
	"./base/elements-repaired/solar-cells.svg": 638,
	"./base/elements-repaired/spacesuit.svg": 639,
	"./base/elements-repaired/vehicle-big.svg": 640,
	"./base/elements-repaired/vehicle-small.svg": 641,
	"./base/elements/background.svg": 642,
	"./base/elements/communication.svg": 643,
	"./base/elements/dome.svg": 644,
	"./base/elements/dorms.svg": 645,
	"./base/elements/drone.svg": 646,
	"./base/elements/entrance.svg": 647,
	"./base/elements/garage.svg": 648,
	"./base/elements/greenhouse-2.svg": 649,
	"./base/elements/greenhouse.svg": 650,
	"./base/elements/ice.svg": 651,
	"./base/elements/lab.svg": 652,
	"./base/elements/rover-curiosity.svg": 653,
	"./base/elements/satellite.svg": 654,
	"./base/elements/solar-cells.svg": 655,
	"./base/elements/stars.png": 656,
	"./base/elements/stars.svg": 657,
	"./base/elements/vehicle-big.svg": 658,
	"./base/elements/vehicle-small.svg": 659,
	"./base/foreground.svg": 660,
	"./base/tag-bg-full-pulsating.svg": 661,
	"./base/tag-bg-full.svg": 662,
	"./base/tag-cone-full.svg": 663,
	"./base/tag-empty-glow.svg": 664,
	"./base/tag-name-bg.svg": 665,
	"./border-bottom.svg": 666,
	"./camera-border.png": 667,
	"./camera-border.svg": 668,
	"./camera/cam-1.png": 263,
	"./camera/cam-2.png": 264,
	"./camera/cam-3.png": 669,
	"./camera/color-vision-thumbnail.png": 265,
	"./camera/map-after.jpg": 266,
	"./camera/map-print.png": 267,
	"./camera/morse-code.svg": 268,
	"./camera/pdf-thumbnail.png": 269,
	"./camera/pdf-thumbnail_2.png": 270,
	"./camera/phet-simulator.png": 121,
	"./camera/sciendomus.png": 271,
	"./camera/solar-cells-before.png": 272,
	"./camera/table.png": 273,
	"./camera/wave-simulator.png": 274,
	"./control-panel.svg": 670,
	"./corner-triangle.svg": 671,
	"./cyoa/rover-navigation.jpg": 672,
	"./cyoa/rover-storm.jpg": 673,
	"./frame-big-cyan.svg": 674,
	"./frame-cyan.svg": 675,
	"./frame-green.svg": 676,
	"./frame-red.svg": 677,
	"./group-badges/arandas.png": 253,
	"./group-badges/bacolor.png": 254,
	"./group-badges/eberswalde.png": 255,
	"./group-badges/jezero.png": 256,
	"./group-badges/korolev.png": 257,
	"./group-badges/lowell.png": 258,
	"./group-badges/magong.png": 259,
	"./group-badges/terby.png": 260,
	"./group-badges/victoria.png": 261,
	"./group-badges/zunil.png": 262,
	"./icon-back.svg": 678,
	"./icon-circle-cyan-full.svg": 679,
	"./icon-circle-cyan.svg": 680,
	"./icon-circle-dark-full.svg": 681,
	"./icon-circle-dark.svg": 682,
	"./icon-circle-light-full.svg": 683,
	"./icon-circle-light.svg": 684,
	"./icon-clock.svg": 685,
	"./icon-down.svg": 686,
	"./icon-drag-handle.svg": 687,
	"./icon-experiment.svg": 688,
	"./icon-fullscreen-contract.svg": 689,
	"./icon-fullscreen-expand.svg": 690,
	"./icon-info.svg": 691,
	"./icon-instructions-group.svg": 692,
	"./icon-instructions-light.svg": 693,
	"./icon-instructions.svg": 694,
	"./icon-loading-white.svg": 695,
	"./icon-loading.gif": 696,
	"./icon-loading.svg": 697,
	"./icon-lock-unlocked.svg": 698,
	"./icon-lock.svg": 699,
	"./icon-logout.svg": 700,
	"./icon-next.svg": 701,
	"./icon-pencil.svg": 702,
	"./icon-play.svg": 703,
	"./icon-print.svg": 704,
	"./icon-settings.svg": 705,
	"./icon-up.svg": 706,
	"./icon-x.svg": 707,
	"./infoMinigames/infoMinigame-1/image-rock-1.png": 275,
	"./infoMinigames/infoMinigame-1/image-rock-2.png": 276,
	"./infoMinigames/infoMinigame-1/image-rock-3.png": 277,
	"./infoMinigames/infoMinigame-1/rock-1-A1.png": 278,
	"./infoMinigames/infoMinigame-1/rock-1-A2.png": 279,
	"./infoMinigames/infoMinigame-1/rock-1-A3.png": 280,
	"./infoMinigames/infoMinigame-1/rock-1-A4.png": 281,
	"./infoMinigames/infoMinigame-1/rock-1-B1.png": 282,
	"./infoMinigames/infoMinigame-1/rock-1-B2.png": 283,
	"./infoMinigames/infoMinigame-1/rock-1-B3.png": 284,
	"./infoMinigames/infoMinigame-1/rock-1-B4.png": 285,
	"./infoMinigames/infoMinigame-1/rock-1-C1.png": 286,
	"./infoMinigames/infoMinigame-1/rock-1-C2.png": 287,
	"./infoMinigames/infoMinigame-1/rock-1-C3.png": 288,
	"./infoMinigames/infoMinigame-1/rock-1-C4.png": 289,
	"./infoMinigames/infoMinigame-1/rock-1-D1.png": 290,
	"./infoMinigames/infoMinigame-1/rock-1-D2.png": 291,
	"./infoMinigames/infoMinigame-1/rock-1-D3.png": 292,
	"./infoMinigames/infoMinigame-1/rock-1-D4.png": 293,
	"./infoMinigames/infoMinigame-1/rock-2-A1.png": 294,
	"./infoMinigames/infoMinigame-1/rock-2-A2.png": 295,
	"./infoMinigames/infoMinigame-1/rock-2-A3.png": 296,
	"./infoMinigames/infoMinigame-1/rock-2-A4.png": 297,
	"./infoMinigames/infoMinigame-1/rock-2-B1.png": 298,
	"./infoMinigames/infoMinigame-1/rock-2-B2.png": 299,
	"./infoMinigames/infoMinigame-1/rock-2-B3.png": 300,
	"./infoMinigames/infoMinigame-1/rock-2-B4.png": 301,
	"./infoMinigames/infoMinigame-1/rock-2-C1.png": 302,
	"./infoMinigames/infoMinigame-1/rock-2-C2.png": 303,
	"./infoMinigames/infoMinigame-1/rock-2-C3.png": 304,
	"./infoMinigames/infoMinigame-1/rock-2-C4.png": 305,
	"./infoMinigames/infoMinigame-1/rock-2-D1.png": 306,
	"./infoMinigames/infoMinigame-1/rock-2-D2.png": 307,
	"./infoMinigames/infoMinigame-1/rock-2-D3.png": 308,
	"./infoMinigames/infoMinigame-1/rock-2-D4.png": 309,
	"./infoMinigames/infoMinigame-1/rock-3-A1.png": 310,
	"./infoMinigames/infoMinigame-1/rock-3-A2.png": 311,
	"./infoMinigames/infoMinigame-1/rock-3-A3.png": 312,
	"./infoMinigames/infoMinigame-1/rock-3-A4.png": 313,
	"./infoMinigames/infoMinigame-1/rock-3-B1.png": 314,
	"./infoMinigames/infoMinigame-1/rock-3-B2.png": 315,
	"./infoMinigames/infoMinigame-1/rock-3-B3.png": 316,
	"./infoMinigames/infoMinigame-1/rock-3-B4.png": 317,
	"./infoMinigames/infoMinigame-1/rock-3-C1.png": 318,
	"./infoMinigames/infoMinigame-1/rock-3-C2.png": 319,
	"./infoMinigames/infoMinigame-1/rock-3-C3.png": 320,
	"./infoMinigames/infoMinigame-1/rock-3-C4.png": 321,
	"./infoMinigames/infoMinigame-1/rock-3-D1.png": 322,
	"./infoMinigames/infoMinigame-1/rock-3-D2.png": 323,
	"./infoMinigames/infoMinigame-1/rock-3-D3.png": 324,
	"./infoMinigames/infoMinigame-1/rock-3-D4.png": 325,
	"./infoMinigames/infoMinigame-2/graph-common.png": 163,
	"./infoMinigames/infoMinigame-2/graph-kitchen.png": 164,
	"./infoMinigames/infoMinigame-2/graph-office.png": 165,
	"./infoMinigames/infoMinigame-2/graph-reactor.png": 166,
	"./infoMinigames/infoMinigame-2/graph-workshop-lab.png": 167,
	"./infoMinigames/infoMinigame-2/rooms.png": 168,
	"./investigations/icon-arrow-up.svg": 326,
	"./investigations/icon-checkbox.svg": 327,
	"./investigations/icon-checkmark.svg": 328,
	"./investigations/icon-delete.svg": 329,
	"./investigations/icon-edit.svg": 330,
	"./investigations/icon-next.svg": 331,
	"./investigations/icon-prev.svg": 332,
	"./investigations/icon-star-selected.svg": 333,
	"./investigations/icon-star.svg": 334,
	"./investigations/investigation-1/clue-1.jpg": 335,
	"./investigations/investigation-1/clue-2.jpg": 336,
	"./investigations/investigation-1/clue-3.jpg": 337,
	"./investigations/investigation-10/clue-2.svg": 338,
	"./investigations/investigation-10/clue-4.svg": 339,
	"./investigations/investigation-12/clue-1.svg": 340,
	"./investigations/investigation-12/clue-2.svg": 341,
	"./investigations/investigation-12/clue-3.svg": 342,
	"./investigations/investigation-12/clue-4.svg": 343,
	"./investigations/investigation-12/clue-5.svg": 344,
	"./investigations/investigation-12/clue-6.svg": 345,
	"./investigations/investigation-12/clue-7.svg": 346,
	"./investigations/investigation-12/clue-8.svg": 347,
	"./investigations/investigation-12/clue-9.svg": 348,
	"./investigations/investigation-13/clue-3.svg": 349,
	"./investigations/investigation-14/clue-1.svg": 350,
	"./investigations/investigation-14/clue-2.svg": 351,
	"./investigations/investigation-2/clue-2.svg": 352,
	"./investigations/investigation-2/clue-3.svg": 353,
	"./investigations/investigation-2/clue-5.svg": 354,
	"./investigations/investigation-2/clue-7.png": 355,
	"./investigations/investigation-3/clue-1.svg": 356,
	"./investigations/investigation-5/clue-2.svg": 357,
	"./investigations/investigation-6/clue-1.svg": 358,
	"./investigations/investigation-7/clue-1.svg": 359,
	"./investigations/investigation-8/clue-1.svg": 360,
	"./investigations/investigation-8/clue-2.svg": 361,
	"./investigations/investigation-8/clue-3.svg": 362,
	"./investigations/investigation-8/clue-4.svg": 363,
	"./investigations/investigation-9/clue-1.svg": 364,
	"./investigations/investigation-9/clue-2.svg": 365,
	"./investigations/investigation-9/clue-3.svg": 366,
	"./investigations/next-step-button.svg": 367,
	"./investigations/striped-background.png": 368,
	"./logo-cgl.svg": 369,
	"./logo-ku-dk-hh.png": 708,
	"./logo-ku.png": 709,
	"./logo-ku.svg": 370,
	"./logo-medium.svg": 710,
	"./logo-novo-nordisk-fonden.png": 711,
	"./logo-novo-nordisk-fonden.svg": 371,
	"./logo-small.png": 712,
	"./logo-small.svg": 713,
	"./logo-textured.svg": 169,
	"./menu-border.png": 714,
	"./minigames/next-button.svg": 715,
	"./minigames/puzzles/energy/chemical-energy.svg": 716,
	"./minigames/puzzles/energy/electric-energy.svg": 717,
	"./minigames/puzzles/energy/kinetic-energy.svg": 718,
	"./minigames/puzzles/energy/nuclear-energy.svg": 719,
	"./minigames/puzzles/energy/potential-energy.svg": 720,
	"./minigames/puzzles/energy/radiation-energy.svg": 721,
	"./minigames/puzzles/energy/thermal-energy.svg": 722,
	"./minigames/puzzles/food/apple.svg": 723,
	"./minigames/puzzles/food/capri-sonne.svg": 724,
	"./minigames/puzzles/food/cheese.svg": 725,
	"./minigames/puzzles/food/coffee.svg": 726,
	"./minigames/puzzles/food/crackers.svg": 727,
	"./minigames/puzzles/food/hazelnuts.svg": 728,
	"./minigames/puzzles/food/marsbar.svg": 729,
	"./minigames/puzzles/food/pizza.svg": 730,
	"./minigames/puzzles/food/potato.svg": 731,
	"./minigames/puzzles/food/salat.svg": 732,
	"./minigames/puzzles/food/smarties.svg": 733,
	"./minigames/puzzles/food/spaghetti.svg": 734,
	"./minigames/puzzles/food/tortilla.svg": 735,
	"./minigames/puzzles/food/tuna.svg": 736,
	"./minigames/puzzles/food/water.svg": 737,
	"./minigames/puzzles/puzzle-1-bg.svg": 738,
	"./minigames/puzzles/puzzle-12-bg.svg": 739,
	"./minigames/puzzles/puzzle-16-bg.svg": 740,
	"./minigames/puzzles/puzzle-17-bg.svg": 741,
	"./minigames/puzzles/puzzle-18-bg.svg": 742,
	"./minigames/puzzles/puzzle-19-bg.svg": 743,
	"./minigames/puzzles/puzzle-2-bg.svg": 744,
	"./minigames/puzzles/puzzle-20-bg.svg": 745,
	"./minigames/puzzles/puzzle-21-bg.svg": 746,
	"./minigames/puzzles/puzzle-22-bg.svg": 747,
	"./minigames/puzzles/puzzle-23-bg.svg": 748,
	"./minigames/puzzles/puzzle-24-bg.svg": 749,
	"./minigames/puzzles/puzzle-25-bg.svg": 750,
	"./minigames/puzzles/puzzle-26-bg.svg": 751,
	"./minigames/puzzles/puzzle-28-bg.svg": 752,
	"./minigames/puzzles/puzzle-29-bg.svg": 753,
	"./minigames/puzzles/puzzle-3-bg.svg": 754,
	"./minigames/puzzles/puzzle-30-bg.svg": 755,
	"./minigames/puzzles/puzzle-31-bg.svg": 756,
	"./minigames/puzzles/puzzle-32-bg.svg": 757,
	"./minigames/puzzles/puzzle-33-bg.svg": 758,
	"./minigames/puzzles/puzzle-34-bg.svg": 759,
	"./minigames/puzzles/puzzle-35-bg.svg": 760,
	"./minigames/puzzles/puzzle-36-bg.svg": 761,
	"./minigames/puzzles/puzzle-37-bg.svg": 762,
	"./minigames/puzzles/puzzle-38-bg.svg": 763,
	"./minigames/puzzles/puzzle-39-bg.svg": 764,
	"./minigames/puzzles/puzzle-4-bg.svg": 765,
	"./minigames/puzzles/puzzle-5-bg.svg": 766,
	"./minigames/puzzles/puzzle-6-bg.svg": 767,
	"./minigames/puzzles/puzzle-7-bg.svg": 768,
	"./minigames/puzzles/puzzle-8-bg.svg": 769,
	"./minigames/puzzles/puzzle-9-bg.svg": 770,
	"./minigames/puzzles/puzzle-time-bg.png": 771,
	"./minigames/puzzles/soundwave/arrows-downwards.svg": 772,
	"./minigames/puzzles/soundwave/arrows-from-center.svg": 773,
	"./minigames/puzzles/soundwave/arrows-to-left.svg": 774,
	"./minigames/puzzles/soundwave/arrows-to-right.svg": 775,
	"./minigames/puzzles/soundwave/arrows-towards-center.svg": 776,
	"./minigames/puzzles/soundwave/arrows-upwards.svg": 777,
	"./minigames/puzzles/soundwave/arrows-with-fluctuations.svg": 778,
	"./minigames/puzzles/soundwave/arrows-without-fluctuations.svg": 779,
	"./minigames/puzzles/soundwave/graph-1.svg": 780,
	"./minigames/puzzles/soundwave/graph-2.svg": 781,
	"./minigames/puzzles/soundwave/graph-3.svg": 782,
	"./minigames/puzzles/soundwave/graph-4.svg": 783,
	"./minigames/puzzles/soundwave/graph-5.svg": 784,
	"./minigames/puzzles/soundwave/graph-grid.svg": 785,
	"./minigames/puzzles/soundwave2/arrow-left-cyan.svg": 786,
	"./minigames/puzzles/soundwave2/arrow-left.svg": 787,
	"./minigames/puzzles/soundwave2/arrow-right-cyan.svg": 788,
	"./minigames/puzzles/soundwave2/arrow-right.svg": 789,
	"./minigames/puzzles/soundwave2/bacteria.svg": 790,
	"./minigames/puzzles/soundwave2/dna.svg": 791,
	"./minigames/puzzles/soundwave2/family.svg": 792,
	"./minigames/puzzles/soundwave2/football-field.svg": 793,
	"./minigames/puzzles/soundwave2/gamma-rays.svg": 794,
	"./minigames/puzzles/soundwave2/infrared-waves.svg": 795,
	"./minigames/puzzles/soundwave2/microwaves.svg": 796,
	"./minigames/puzzles/soundwave2/molecule.svg": 797,
	"./minigames/puzzles/soundwave2/needle.svg": 798,
	"./minigames/puzzles/soundwave2/radio-waves-radio.svg": 799,
	"./minigames/puzzles/soundwave2/radio-waves-router.svg": 800,
	"./minigames/puzzles/soundwave2/ultraviolet.svg": 801,
	"./minigames/puzzles/soundwave2/virus.svg": 802,
	"./minigames/puzzles/soundwave2/x-rays.svg": 803,
	"./minigames/puzzles/soundwaveMath/wave-1.svg": 804,
	"./minigames/puzzles/soundwaveMath/wave-10.svg": 805,
	"./minigames/puzzles/soundwaveMath/wave-11.svg": 806,
	"./minigames/puzzles/soundwaveMath/wave-2.svg": 807,
	"./minigames/puzzles/soundwaveMath/wave-3.svg": 808,
	"./minigames/puzzles/soundwaveMath/wave-4.svg": 809,
	"./minigames/puzzles/soundwaveMath/wave-5.svg": 810,
	"./minigames/puzzles/soundwaveMath/wave-6.svg": 811,
	"./minigames/puzzles/soundwaveMath/wave-7.svg": 812,
	"./minigames/puzzles/soundwaveMath/wave-8.svg": 813,
	"./minigames/puzzles/soundwaveMath/wave-9.svg": 814,
	"./morse-code-print.svg": 170,
	"./next-step-button-small.svg": 815,
	"./next-step-button.svg": 816,
	"./pages/beginning.png": 817,
	"./pages/image-from-mars-1.png": 818,
	"./pages/image-from-mars-2.gif": 819,
	"./pages/image-from-mars-3.png": 820,
	"./pages/image-from-mars-4.png": 821,
	"./pages/image-from-mars-5.png": 822,
	"./pages/image-from-mars-6.png": 823,
	"./pages/mars-rover.png": 824,
	"./pages/mars-solopgang.jpeg": 825,
	"./pages/marsbasen-eksplosionen-skitse-a.png": 826,
	"./pages/marsbasen-eksplosionen-skitse-b.png": 827,
	"./pages/orbit-investigation.png": 828,
	"./pages/orbit-seasons-0.png": 829,
	"./pages/orbit-seasons-1.png": 830,
	"./pages/orbit-seasons-2.png": 831,
	"./pages/orbit-seasons-3.png": 832,
	"./pages/orbit.gif": 833,
	"./pages/solar-system-with-metheor.png": 834,
	"./pages/wave-build-a-welding-mask.png": 835,
	"./prev-step-button.svg": 836,
	"./rocket-loading.svg": 372,
	"./rocket-tail.png": 373,
	"./rotary-button.svg": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;